<template>
  <div>
    <!-- Address -->
    <div v-if="log.log_type === 'client' && log.type === 'created' && model_log === 'Address'" class="record">
      <div v-if="log.new_values.address_type !== null && 'address_type' in log.new_values" class="row">
        <div class="col-5"><strong>Address Type</strong></div>
        <div class="col-7">{{ log.new_values.address_type }}</div>
      </div>
      <div v-if="log.new_values.building !== null && 'building' in log.new_values" class="row">
        <div class="col-5"><strong>Building</strong></div>
        <div class="col-7">{{ log.new_values.building }}</div>
      </div>
      <div v-if="log.new_values.street !== null && 'street' in log.new_values" class="row">
        <div class="col-5"><strong>Street</strong></div>
        <div class="col-7">{{ log.new_values.street }}</div>
      </div>
      <div v-if="log.new_values.locality !== null && 'locality' in log.new_values" class="row">
        <div class="col-5"><strong>Locality</strong></div>
        <div class="col-7">{{ log.new_values.locality }}</div>
      </div>
      <div v-if="log.new_values.city_town !== null && 'city_town' in log.new_values" class="row">
        <div class="col-5"><strong>City/Town</strong></div>
        <div class="col-7">{{ log.new_values.city_town }}</div>
      </div>
      <div v-if="log.new_values.county !== null && 'county' in log.new_values" class="row">
        <div class="col-5"><strong>County</strong></div>
        <div class="col-7">{{ log.new_values.county }}</div>
      </div>
      <div v-if="log.new_values.postcode !== null && 'postcode' in log.new_values" class="row">
        <div class="col-5"><strong>Postcode</strong></div>
        <div class="col-7">{{ log.new_values.postcode }}</div>
      </div>
    </div>
    <div v-if="(log.type === 'restored' || log.type === 'updated') && model_log === 'Address'" class="record">
      <div v-if="log.new_values.address_type !== null && 'address_type' in log.new_values" class="row">
        <div class="col-5"><strong>Address Type</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ log.new_values.address_type }}</div>
          <div class="old_value">{{ log.old_values.address_type }}</div>
        </div>
      </div>
      <div v-if="log.new_values.building !== null && 'building' in log.new_values" class="row">
        <div class="col-5"><strong>Building</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ log.new_values.building }}</div>
          <div class="old_value">{{ log.old_values.building }}</div>
        </div>
      </div>
      <div v-if="log.new_values.street !== null && 'street' in log.new_values" class="row">
        <div class="col-5"><strong>Street</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ log.new_values.street }}</div>
          <div class="old_value">{{ log.old_values.street }}</div>
        </div>
      </div>
      <div v-if="log.new_values.locality !== null && 'locality' in log.new_values" class="row">
        <div class="col-5"><strong>Locality</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ log.new_values.locality }}</div>
          <div class="old_value">{{ log.old_values.locality }}</div>
        </div>
      </div>
      <div v-if="log.new_values.city_town !== null && 'city_town' in log.new_values" class="row">
        <div class="col-5"><strong>City/Town</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ log.new_values.city_town }}</div>
          <div class="old_value">{{ log.old_values.city_town }}</div>
        </div>
      </div>
      <div v-if="log.new_values.county !== null && 'county' in log.new_values" class="row">
        <div class="col-5"><strong>County</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ log.new_values.county }}</div>
          <div class="old_value">{{ log.old_values.county }}</div>
        </div>
      </div>
      <div v-if="log.new_values.postcode !== null && 'postcode' in log.new_values" class="row">
        <div class="col-5"><strong>Postcode</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ log.new_values.postcode }}</div>
          <div class="old_value">{{ log.old_values.postcode }}</div>
        </div>
      </div>
    </div>
    <div v-if="(log.type === 'deleted') && model_log === 'Address'" class="record">
      <div v-if="log.old_values.address_type !== null && 'address_type' in log.old_values" class="row">
        <div class="col-5"><strong>Address Type</strong></div>
        <div class="col-7">
          <div class="old_value">{{ log.old_values.address_type }}</div>
        </div>
      </div>
      <div v-if="log.old_values.building !== null && 'building' in log.old_values" class="row">
        <div class="col-5"><strong>Building</strong></div>
        <div class="col-7">
          <div class="old_value">{{ log.old_values.building }}</div>
        </div>
      </div>
      <div v-if="log.old_values.street !== null && 'street' in log.old_values" class="row">
        <div class="col-5"><strong>Street</strong></div>
        <div class="col-7">
          <div class="old_value">{{ log.old_values.street }}</div>
        </div>
      </div>
      <div v-if="log.old_values.locality !== null && 'locality' in log.old_values" class="row">
        <div class="col-5"><strong>Locality</strong></div>
        <div class="col-7">
          <div class="old_value">{{ log.old_values.locality }}</div>
        </div>
      </div>
      <div v-if="log.old_values.city_town !== null && 'city_town' in log.old_values" class="row">
        <div class="col-5"><strong>City/Town</strong></div>
        <div class="col-7">
          <div class="old_value">{{ log.old_values.city_town }}</div>
        </div>
      </div>
      <div v-if="log.old_values.county !== null && 'county' in log.old_values" class="row">
        <div class="col-5"><strong>County</strong></div>
        <div class="col-7">
          <div class="old_value">{{ log.old_values.county }}</div>
        </div>
      </div>
      <div v-if="log.old_values.postcode !== null && 'postcode' in log.old_values" class="row">
        <div class="col-5"><strong>Postcode</strong></div>
        <div class="col-7">
          <div class="old_value">{{ log.old_values.postcode }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "client",
  props: {log: null, model_log: null},
}
</script>
